// project modules
import { getBaseUrl, sendRequest } from '../helpers/apiHelper';

export const getList = async (abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/DiscountCoupons`, 'get', null, null, abortSignal);
};

export const getItemById = async (id: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/DiscountCoupons/${id}`, 'get', null, null, abortSignal);
};

export const createItem = async (data: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/DiscountCoupons`, 'post', data, null, abortSignal);
};

export const updateItem = async (id: any, data: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/DiscountCoupons/${id}`, 'put', data, null, abortSignal);
};

export const deleteItem = async (id: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/DiscountCoupons/${id}`, 'delete', null, null, abortSignal);
};

